module.exports = __webpack_public_path__ + "static/media/scene5_furba4.34ba2bb9.wav";